<div id="landing" class="flex">
  <div name="right-banner" class="hidden md:block flex justify-center md:w-1/2 px-20">
    <div class="mb-8 flex flex-col justify-center">
      <div class="pt-12 pb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty?.thumb}}>
      </div>
      <div class="flex justify-between items-end">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty?.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty?.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty?.baths}}</span> ba | <span
              class="font-bold">{{modelProperty?.sqft}}</span> sqft</p>
        </div>
      </div>
      <div class="pb-4">
        <div>{{modelProperty?.title}}</div>
      </div>
      <div>
        <div *ngIf="splashHTML != null" class="bg-white h-32" [innerHTML]="splashHTML"></div>
      </div>
    </div>
  </div>
  <div name="main" class="p-8 flex flex-col sm:w-auto md:w-1/2  bg-white">
    <div class="flex flex-col sm:w-auto md:hidden">
      <div class="mb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty?.thumb}}>
      </div>
      <div class="flex justify-between items-end ">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty?.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty?.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty?.baths}}</span> ba | <span
              class="font-bold">{{modelProperty?.sqft}}</span> sqft</p>
        </div>
      </div>
      <div>
        <div>{{modelProperty?.title}}</div>
      </div>
    </div>
    <div class="md:px-16">
      <h2 class="text-4xl my-2 use-rhetorik-sans">We are thrilled that you have chosen to rent your next home with Tricon.
      </h2>
      <p>Please ensure you have the following documents on hand in order to complete the application:</p>
      <ul class="list-disc pl-6">
        <li>{{paymentOptions}}</li>
        <li>Proof of Income (e.g. one month of paystubs, three months of bank statements) verifying your combined
          household income of at least {{rentMultiplier}} the monthly rent</li>
        <li>Contact Information for rental references/former landlords for the past two years.</li>
      </ul>
      <br>
      <p>Each resident over the age of 18 must submit a separate rental application and provide a unique email address
        that is different from the other applicants. {{appFee}}.</p>
      <br>
      <p>Due to the high demand for our homes, at times, there may be more than one applicant group/family applying for
        the same home. We encourage you to complete your application promptly to ensure you are approved for the home
        you desire. Homes are leased on a first completed and approved application basis.</p>
      <br>
      <p>Our customer service representatives are available to assist you should you have any questions while completing
        the application. 844 874 2661 or <a href="mailto:info@triconah.com">info@triconah.com</a>.</p>
      <br>
      <p>Read our <a href="{{ termsOfAgreementUrl }}" target="_blank">Terms of Agreement and Qualification Criteria
          (PDF)</a>.</p>
      <br>
      <div class="text-center">
        <button mat-flat-button color="primary" class="mb-4" (click)="onNewApplicantClick()">START APPLICATION</button>
        <p class="info-text">If you are a returning applicant, please <a (click)="goToDashboard()"
            class="dashboard-link">click here</a> to return to your application.</p>
        <button mat-button color="accent" class=" mt-6" (click)="goToDashboard()">CHECK THE STATUS OF YOUR
          APPLICATION</button>
      </div>
    </div>
  </div>
</div>
